import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { map, isEmpty, empty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { adminContent, ByCell, dateTimeCell } from "./Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Disciplines.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { DomainEntity } from "../ClientTypes.fs.js";
import { Components_UnDelete, Components_Delete } from "../Modals/Modal.fs.js";
import { Create } from "../Modals/Discipline.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

const columns = ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);

function rowRender(projectId, discipline) {
    return new Row(discipline.Id, ofArray([new Cell("name", discipline.Name), new Cell("lastModifiedOn", dateTimeCell(discipline.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: discipline.LastModifiedBy,
    }))]));
}

export function Disciplines(disciplinesInputProps) {
    let actions, disciplines, disciplines_1;
    const projectId = disciplinesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedDisciplines = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Disciplines",
        columns: columns,
        initialFilters: toList(delay(() => (showDeleted ? singleton(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (disciplineParams) => many(projectId, empty(), disciplineParams),
        fetchCount: (disciplineParams_1) => count(projectId, disciplineParams_1),
        rowRender: (discipline) => rowRender(projectId, discipline),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedDisciplines);
    return adminContent(toList(delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_2) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedDisciplines)]]))))) : singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_3) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedDisciplines)]])))))))))))), table, (action != null) ? ((actions = action, (actions === "delete") ? ((disciplines = map((Item) => (new DomainEntity(13, [Item])), selectedDisciplines), createElement(Components_Delete, {
        projectId: projectId,
        entities: disciplines,
        close: close,
    }))) : ((actions === "unDelete") ? ((disciplines_1 = map((Item_1) => (new DomainEntity(13, [Item_1])), selectedDisciplines), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: disciplines_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    })))) : undefined);
}

